module.exports = __webpack_public_path__ + "static/media/organisation.6c5e2cb1.svg";